/**
 * Lexical editor configuration.
 */

import { InitialConfigType } from "@lexical/react/LexicalComposer";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { ListNode, ListItemNode } from "@lexical/list";
import { CodeNode } from "@lexical/code";
import { LinkNode } from "@lexical/link";
import { DimensionTagNode } from "./nodes/DimensionTagNode";

// ============================================
// Custom Nodes
// ============================================

/**
 * All custom nodes for registration with Lexical.
 */
export const CUSTOM_NODES = [
  HeadingNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  CodeNode,
  LinkNode,
  DimensionTagNode,
  // TODO: Add PersonMentionNode, FileMentionNode
];

// ============================================
// Theme
// ============================================

/**
 * Lexical theme for styling editor elements.
 */
export const LEXICAL_THEME = {
  paragraph: "mb-2",
  heading: {
    h1: "text-2xl font-bold mb-4",
    h2: "text-xl font-semibold mb-3",
    h3: "text-lg font-medium mb-2",
  },
  list: {
    ul: "list-disc ml-4 mb-2",
    ol: "list-decimal ml-4 mb-2",
    listitem: "mb-1",
  },
  text: {
    bold: "font-semibold",
    italic: "italic",
    underline: "underline",
    strikethrough: "line-through",
    code: "bg-grey-100 px-1 py-0.5 rounded font-mono text-sm",
  },
  quote: "border-l-4 border-grey-300 pl-4 italic text-grey-600",
};

// ============================================
// Editor Config Factory
// ============================================

/**
 * Creates an initial Lexical editor configuration.
 */
export function createEditorConfig(
  namespace: string,
  onError?: (error: Error) => void
): InitialConfigType {
  return {
    namespace,
    nodes: CUSTOM_NODES,
    theme: LEXICAL_THEME,
    onError:
      onError || ((error: Error) => console.error("Lexical error:", error)),
  };
}
